<div class="col-xs-12">
  <div class="panel panel-default">
    <div class="panel-heading">
      Filtros
    </div>
    <div class="panel-body">
      <form onsubmit="buscarClick()">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <label for="descricao">Descrição</label>
            <input class="form-control input-sm" ng-model="filters.descricao" type="text" id="descricao" name="descricao">
          </div>

          <div class="col-xs-12 col-md-6">
            <label>&nbsp;</label><br>
            <button class="btn btn-success" ng-click="buscarClick()">
              Buscar <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>